import { DisplayContentFooter } from '../components/DisplayContentFooter';
import { Rates } from './rates/Rates';
import { Calendars } from './calendars/Calendars';
import { ChargeOffReasons } from './charge-off-reasons/ChargeOffReasons';
import { TransactionReasons } from './transaction-reasons/TransactionReasons';
import { MemoCategories } from './memo-categories/MemoCategories';
import { AccountStatusDefinitions } from './account-status-definitions/AccountStatusDefinitions';
import {AccountTreatmentIndicators} from "./account-treatment-indicators/AccountTreatmentIndicators";
import { Tab } from 'semantic-ui-react';
import { ComponentErrorBoundary } from '@app/utilities';
import { AccountFlagDefinitions } from './account-flag-definitions/AccountFlagDefinitions';
import { ClosureReasons } from './closure-reasons/ClosureReasons';

export function ReferenceData() {
  const style = {
    width: '100%',
    margin: 'auto',
    height: '710px',
    minWidth: '734px',
  };

  const panes = [
    {
      menuItem: 'Rates',
      render: () => (
        <Tab.Pane>
          <Rates />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Calendars',
      render: () => (
        <Tab.Pane>
          <Calendars />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Charge Off Reasons',
      render: () => (
        <Tab.Pane>
          <ChargeOffReasons />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Closure Reasons',
      render: () => (
        <Tab.Pane>
          <ClosureReasons />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Transaction Reasons',
      render: () => (
        <Tab.Pane>
          <TransactionReasons />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Account Status Definitions',
      render: () => (
          <Tab.Pane>
            <AccountStatusDefinitions />
          </Tab.Pane>
      ),
    },
    {
      menuItem: 'Account Flag Definitions',
      render: () => (
          <Tab.Pane>
            <AccountFlagDefinitions />
          </Tab.Pane>
      ),
    },
    {
      menuItem: 'Account Treatment Indicators',
      render: () => (
          <Tab.Pane>
            <AccountTreatmentIndicators />
          </Tab.Pane>
      ),
    },
    {
      menuItem: 'Memo Categories',
      render: () => (
          <Tab.Pane>
            <MemoCategories />
          </Tab.Pane>
      ),
    },
  ];

  return (
    <ComponentErrorBoundary>
      <div style={style}>
        <Tab panes={panes}  />
      </div>
      <DisplayContentFooter />
    </ComponentErrorBoundary>
  );
}
